import Marquee from "react-fast-marquee";

const WORDS = [
  { t: "TAP IN", c: "text-chrome" },
  { t: "PREVIEW", c: "text-[#D65BB4]" },
  { t: "LEASE", c: "text-stroke" },
  { t: "OWN IT", c: "text-[#4DBDBE]" },
];

const MarqueeBand = () => (
  <section
    data-testid="marquee-band"
    className="w-full overflow-hidden py-10 md:py-14 border-y border-white/10 relative z-10 bg-black/50 backdrop-blur-md"
  >
    <Marquee speed={55} gradient={false} pauseOnHover>
      <div className="flex items-center">
        {WORDS.map((w) => (
          <span key={w.t} className="flex items-center">
            <span className={`font-marquee uppercase text-6xl md:text-8xl lg:text-9xl px-8 ${w.c}`}>
              {w.t}
            </span>
            <span className="text-[#D65BB4] text-5xl">•</span>
          </span>
        ))}
      </div>
    </Marquee>
  </section>
);

export default MarqueeBand;
